export default {
  leave: {
    crud: {
      create: "Urlaubsantrag hinzufügen"
    },
    menu: {
      leave_accruals: "Urlaubsrücklagen",
      leave_requests: "Urlaubsanträge",
      leave_approvals: "ausstehende Urlaubsansträge"
    },
    hourly: "stündlich",
    daily: "täglich",
    type: "Art des Urlaubs",
    begin_time: "Startzeit",
    end_time: "Endzeit",
    begin_date: "Startdatum",
    end_date: "Enddatum",
    approved_time: "Bestätigungszeit",
    request_time: "Antragszeit",
    approve_or_reject: "Genehmigen oder Ablehnen",
    status: "Status",
    no_approver: "nicht bestätigt",
    manager: "Urlaubsmanager:In",
    managers: "Urlaubsmanager:In",
    balance: "Bilanz",
    not_leave_accruals: "Dieser Mitarbeiter kann noch keinen Urlaub beantragen",
    permission: {
      employee_leave_approver_message: "Dieser Mitarbeiter kann Anträge anderer Mitarbeiter bestätigen",
      employee_not_leave_approver_message: "Dieser Mitarbeiter kann Anträge anderer Mitarbeiter nicht bestätigen",
      employee_shift_approver_message: "Dieser Mitarbeiter kann anderen Mitarbeitern Arbeitsschichten zuteilen",
      employee_not_shift_approver_message:
        "Dieser Mitarbeiter kann anderen Mitarbeitern keine Arbeitsschichten zuteilen",
      employee_overtime_approver_message: "Dieser Mitarbeiter kann Überstundenanträge anderer Mitarbeiter bestätigen",
      employee_not_overtime_approver_message:
        "Dieser Mitarbeiter kann Überstundenanträge anderer Mitarbeiter nicht bestätigen"
    },
    notification: {
      employee_receiver_leave_notification_message:
        "Diese Mitarbeiter können Bestätigungen von anderen Mitarbeitern erhalten",
      employee_not_receiver_leave_notification_message:
        "Diese Mitarbeiter können keine Bestätigungen von anderen Mitarbeitern erhalten",
      employee_receiver_shift_notification_message:
        "Diese Mitarbeiter können Schichtzuteilungsbenachrichtungen von anderen Mitarbeitern erhalten.",
      employee_not_receiver_shift_notification_message:
        "Diese Mitarbeiter können keine Schichtzuteilungsbenachrichtigungen von anderen Mitarbeitenr erhalten",
      employee_receiver_overtime_notification_message:
        "Diese Mitarbeiter können Benachrichtigungen zu Überstundenanträgen von anderen Mitarbeitern erhalten",
      employee_not_receiver_overtime_notification_message:
        "Diese Mitarbeiter können keine Benachrichtigungen zu Überstundenanträgen von anderen Mitarbeitern erhalten",
      employee_leave_notification_enabled: "This employee can receive Time Off notifications",
      employee_leave_notification_disabled: "This employee cannot receive Time Off notifications"
    },
    respect: "Die Bestätigungen der oben aufgelisteten Manager:Innen werden prioritiert behandelt",
    order_is_important: "Die Reihenfolge der Manager:Innen ist von Belang",
    already_selected_manager: "Sie haben diesen Manager bereits gewählt",
    there_is_no_leave_manager: "Keine zuständigen Urlaubsmanager verfügbar",
    add_leave_manager: "Urlaubsmanager hinzufügen",
    used: "verbraucht",
    remaining: "noch verfügbar",
    on_leave: "im Urlaub",
    period: "Periode",
    duration: "Dauer",
    periods: {
      first_half: "1.Hälfte",
      second_half: "2.Hälfte",
      first_quarter: "1.Quartal",
      second_quarter: "2.Quartal",
      third_quarter: "3.Quartal",
      fourth_quarter: "4.Quartal"
    },
    request: {
      this_day_does_not_count_as_leave: "Dieser Tag wird nicht als Urlaub gezählt",
      leave_balance: "Urlaubsbilanz ",
      max_exceed_leave_balance: "maximale Urlaubsbilanz überschritten",
      leave_request_count: "Anzahl Urlaubsanträge",
      used: "verbraucht",
      remaining: "verfügbar",
      approved: "bestätigen",
      denied: "ablehnen",
      leave_decreased_count: "Time Off will decrease",
      requested_leave_type_documents: "Required document for Time Off",
      required_document_message:
        " | There is {count} document you need to upload | There are {count} documents you need to upload"
    },
    accruals: {
      name: "Name",
      count: "Anzahl",
      used: "verbraucht",
      previous_balance: "bisherige Bilanz"
    },
    approvals: {
      leave_approval: "Urlaubsbestätigung",
      message:
        "Möchten Sie bestätigen, dass Mitarbeiter <b>{0}</b> eine Gesamtsumme von <b>{3}</b> Urlaubstagen <b>{4}</b> im Zeitraum  <b>{1}</b> - <b>{2}</b> eingereicht hat?"
    },
    cancels: {
      leave_cancel: "Urlaub widerrufen",
      message: "Ihr Grund für den Widerruf der Genehmigung?",
      error_message: "Ihr Kündigungsgrund? Platz wird benötigt"
    },
    error_messages: {
      notice_period_error: "Dieser Urlaub muss mindestens {0} Tage im Voraus beantragt werden",
      max_consecutive_error: "Sie können bis zu {0} Urlaubstage auf einmal beantragen",
      min_consecutive_error: "Sie können {0} Urlaubstage auf einmal beantragen",
      leave_request_exist_error: "Es liegt ein Urlaubsantrag für diesen Zeitraum vor",
      total_leave_balance_error1: "Ihre Restbilanz ist nicht ausreichend für diesen Urlaubszeitraum",
      total_leave_balance_error2:
        "Ihre Restbilanz ist nicht ausreichend für diesen Urlaubszeitraum. Sie können ein Maximum von {0} restlichen Urlaubstagen aus Ihrer Bilanz entnehmen.",
      leave_balance_error1: "Weil du nicht genug Gleichgewicht hast",
      leave_balance_error2: "Tagesvorschuss wird von Ihrem Guthaben abgezogen"
    },
    e_signature: "E-signature",
    e_signature_leave_form: "E-signed Time Off Form",
    leave_form: "Time Off Form",
    leave_cancel: "Erlaubnis widerrufen",
    signed: "Signed",
    not_signed: "Not Signed",
    leave_form_name: "time_off_form_"
  },
  leave_request_status: {
    pending: "ausstehend",
    PENDING: "ausstehend",
    approved: "bestätigt",
    APPROVED: "bestätigt",
    denied: "abgelehnt",
    DENIED: "abgelehnt",
    cancelled: "abgebrochen",
    CANCELLED: "abgebrochen",
    need_extra_detail: "Es werden weitere Informationen benötigt",
    NEED_EXTRA_DETAIL: "Es werden weitere Informationen benötigt",
    STOPPED: "Stopped",
    stopped: "Stopped",
    not_come: "Not Come",
    NOT_COME: "Not Come",
    null: "Unknown",
    NULL: "Unknown",
    undefined: "Unknown",
    UNDEFINED: "Unknown",
    closed: "Closed",
    CLOSED: "Closed"
  },
  time_duration: {
    hour: "Stunde",
    minute: "Minute",
    second: "Zweite"
  },
  leave_type: {
    paid: "bezahlt",
    unpaid: "unbezahlt",
    on_duty: "im Dienst",
    restricted_holiday: "eingeschränkter Feiertag"
  },
  leave_status: {
    APPROVED: "bestätigt",
    PENDING: "ausstehend",
    DENIED: "abgelehnt",
    CANCELLED: "abgebrochen",
    NEED_EXTRA_DETAIL: "Es werden zusätzliche Details benötigt",
    not_come: "Keine Zeiten verfügbar",
    NOT_COME: "No time has come"
  },
  leave_duration: {
    FULL_DAY: "Voller Arbeitstag",
    HALF_DAY: "halber Arbeitstag",
    QUARTER_DAY: "Ein-Viertel Arbeitstag",
    HOURLY_DAY: "Arbeitstag nach Stunden",
    HOURLY: "stündlich"
  },
  documentVisibleByHR:
    "With this upload, I understand and consent that the document will be visible by HR, Time & Attendance and Payroll OPS team and your Team Manager."
};
